import React from 'react'
import Container from './Container'
import Button from './Button'


const Access = () => {
	return <div className="Access Section" id="access">
		<Container>

			<h2>Доступ</h2>
			<p>Игра работает на движке Unity и доступна для Windows</p>
			<h3>Open Source</h3>
			<p>Исходный код игры доступен на Github. Если Вы хотите добавить функционал, исправить ошибку или прото изучить код, вы знаете что делать!</p>

			<div className="equal-links">
				<Button link="./AlternativeTycoon.zip" download>Скачать (zip)</Button>
				<Button link="https://github.com/Tupi8mpl/AlternativeTycoon2" newtab>Souce code</Button>
			</div>

		</Container>
	</div>
}

export default Access